import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import Select from "../../Select/Select";
import { styles } from "../../../pages/Storage/shared/styles";
import { FormikProps } from "formik";
import { InitialValues } from "../../../pages/Storage/models/types";

interface RetrievalFieldsProps {
  formik: FormikProps<InitialValues>;
  isViewing: boolean;
  nfs: string[];
}

export const RetrievalFields: React.FC<RetrievalFieldsProps> = ({
  formik,
  isViewing,
  nfs,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Select
          label="Nº e Série da NF"
          getOptionItemLabel={(value) => value ?? ""}
          getSelectedOptionLabel={(value) => value ?? ""}
          options={nfs?.map((nf) => ({ option: nf }))}
          value={formik.values.orderNumberAndSeries}
          // eslint-disable-next-line @typescript-eslint/promise-function-async
          onChange={(value) =>
            formik.setFieldValue("orderNumberAndSeries", value)
          }
          isDisabled={isViewing}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography
          color="shadesOfDark.dark"
          sx={{ mb: 0.5, fontWeight: 700, fontFamily: "Open Sans" }}
        >
          Nº da fatura
        </Typography>
        <TextField
          variant="outlined"
          size="small"
          placeholder="Insira"
          value={formik.values.referenceDocument}
          onChange={async ({ target: { value } }) =>
            // eslint-disable-next-line @typescript-eslint/return-await
            formik.setFieldValue("referenceDocument", value)
          }
          disabled={isViewing}
          sx={styles.textField}
        />
      </Grid>
    </Grid>
  );
};
